export const US_GEO_COHORT_POSTFIX = '_am'

export const isUsGeoCohort = (cohort: string): boolean =>
  cohort.endsWith(US_GEO_COHORT_POSTFIX)
